/**
 * @fileoverview POST handler for the "/apps/engagement_reports/engagement_report" endpoint
 */
import fetch from "@lib/fetch";

import { reactQueryMutationAdapter } from "../reactQueryFetcherAdapters";
import { appsEngagementReportsEngagementReportCacheKeys } from "./constants";
import type {
  PostAppsEngagementReportsEngagementReportProps,
  AppsEngagementReportsEngagementReportResult,
} from "./types";

export const postAppsEngagementReportsEngagementReport = reactQueryMutationAdapter(
  appsEngagementReportsEngagementReportCacheKeys,
  (props: PostAppsEngagementReportsEngagementReportProps): Promise<AppsEngagementReportsEngagementReportResult> => {
    return fetch("/apps/engagement_reports/engagement_report", "POST", props);
  }
);
